module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div id=\"timerTitle\" class=\"prop-header hide\"><span class=\"prop-label\">Timer</span></div>\r\n<div class=\"nav-position prop-detail\" >\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3 prop-sublabel\">Start</div>\r\n        <div class=\"col-md-3  nopadding\"><input type=\"text\" value=\"")
    ; __append(escapeFn( startTime ))
    ; __append("\" name=\"startTime\" /></div>\r\n        <div class=\"col-md-3 prop-sublabel\">End</div>\r\n        <div class=\"col-md-3 nopadding\"><input type=\"text\" value=\"")
    ; __append(escapeFn( endTime ))
    ; __append("\" name=\"endTime\" /></div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3 prop-sublabel\">Interval</div>\r\n        <div class=\"col-md-3  nopadding\"><input type=\"text\" value=\"")
    ; __append(escapeFn( displayInterval ))
    ; __append("\" name=\"interval\" /></div>\r\n        <div class=\"col-md-6\" style=\"padding-right: 0px;\">\r\n            <select id=\"measure\" name=\"measure\" >\r\n                <option value=\"Seconds\">Seconds</option>\r\n                <option value=\"Minutes\">Minutes</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3 prop-sublabel\">Direction</div>\r\n        <div class=\"col-md-3 nopadding\">\r\n            <select id=\"direction\" name=\"direction\">\r\n                <option value=\"up\">Up</option>\r\n                <option value=\"down\">Down</option>\r\n            </select>\r\n        </div>\r\n        <div class=\"col-md-6 prop-sublabel\">\r\n            <input type=\"checkbox\" name=\"loop\"  /> Loop\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n")
  }
  return __output;

}